import "./index.scss";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { loadClientConfig } from "./config/app-config";

// Bootstrap: load configuration from the continuum server FIRST, then pull in
// the rest of the app via dynamic import. Everything below ./render-app reads
// config.* at import time, so it must not be imported until config is populated.
loadClientConfig()
  .then(async () => {
    const { renderApp } = await import("./render-app");
    renderApp();
  })
  .catch((e) => {
    // Bootstrap failed, so there is no app. Say so ON THE PAGE — a console error
    // alone is a blank white screen to the user, which is exactly how the poisoned
    // config.js presented for a whole day: login "just didn't work", with nothing
    // on screen to explain it.
    console.error("[bootstrap] failed to start app:", e);
    const root = document.getElementById("root");
    if (root) {
      const msg = e instanceof Error ? e.message : String(e);
      root.innerHTML = `
        <div style="font-family: system-ui, sans-serif; max-width: 40rem; margin: 4rem auto; padding: 0 1rem; color: #333;">
          <h1 style="font-size: 1.25rem;">This app could not start</h1>
          <p style="color: #666; font-size: 0.9rem;">${msg}</p>
          <p style="color: #666; font-size: 0.9rem;">
            If this persists, try a hard reload (or clear this site's cache).
          </p>
        </div>`;
    }
  });
